module.exports = __webpack_public_path__ + "media/images/flags/64/Cayman-Islands-e4bed9277dc8dcb79c886b54f79789d0.png";